<template>
  <div id="container">
    <div class="item-box-content" style="padding-bottom:0px">
      <div class="title-font-style">
        <span>退票信息</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 20px 0 27px;">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="退票编号：">{{ queryParams.subNumber }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票类型：">{{ queryParams.invoiceType }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退票类型：">开票退票</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="公司名称：">{{ queryParams.cusName }}</el-form-item>
          </el-col>
          <div v-if="queryParams.subType===2">
            <el-col :span="8">
              <el-form-item label="税号：">{{ queryParams.taxNumber }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="银行账号：">{{ queryParams.bankNumber }}</el-form-item>
            </el-col>
          </div>
          <el-col :span="8" v-else>
            <el-form-item label="关联发票编号：">{{ queryParams.invoiceCode }}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="queryParams.subType===2">
          <el-col :span="8">
            <el-form-item label="开票地址：">{{ queryParams.invoiceAddress }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开户行：">{{ queryParams.bankOpen }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开票电话：">{{ queryParams.invoicePhone }}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="申请时间：">{{ queryParams.createDate | dateFilterL }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退票原因：">{{ queryParams.mark||'--' }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content details-line-height" style="padding-bottom:0px">
      <div class="title-font-style">
        <span>票据信息</span>
      </div>
      <el-form style="padding:20px 20px 0 27px;">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="退票状态：">
              {{ queryParams.state === 4
              ? "已退票"
              : queryParams.state === 3||queryParams.state === 5
              ? "审核不通过"
              : "退票审核"
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票金额：">{{ queryParams.amount|priceFilter }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票税额：">{{ queryParams.taxAmount|priceFilter }}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="发票编号：">{{ queryParams.invoiceCode||'--' }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="处理人：">{{ queryParams.processUser||'--' }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退票时间：">{{ queryParams.processDate | dateFilterL }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content" style="padding-bottom:0px">
      <div class="title-font-style">
        <span>收票信息</span>
      </div>
      <el-form style="padding:20px 20px 0 27px;" label-width="70px" label-position="left" >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收票人：">{{ queryParams.receivePeople }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">{{ queryParams.receivePhone }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="收票地址："
            >{{ queryParams.receiveProvince }} {{ queryParams.receiveAddress }}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="queryParams.state===4 && queryParams.invoiceType!=='红字发票'">
          <el-col :span="8">
            <el-form-item label="物流公司：">
              <el-input v-model="queryParams.logsticCompany"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="padding:0px;">
            <el-col :span="18">
              <el-form-item label="物流单号：">
                <el-input v-model="queryParams.logsticNumber"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="onStore">保存</el-button>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>产品详情</span>
      </div>
      <el-table
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="list"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        height="378"
      >
        <el-table-column label="销售合同编号" fixed width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="approval" @click="onContractCode(scope.row)">{{ scope.row.contractCode }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="customerContractCode"
          label="客户合同编号"
          width="120"
        ></el-table-column>
        <el-table-column width="120" prop="proName" label="产品名称" show-overflow-tooltip></el-table-column>
        <el-table-column width="120" prop="proType" label="型号">
          <template slot-scope="scope">
            <span class="approval" @click="onProductDetail(scope.row)">{{ scope.row.proType }}</span>
          </template>
        </el-table-column>
        <el-table-column width="120" prop="orderNumber" label="订货号"></el-table-column>
        <el-table-column prop="cbUnit" label="单位"></el-table-column>
        <el-table-column prop="count" label="数量"></el-table-column>
        <el-table-column prop="cbPrice" label="销售单价">
          <template slot-scope="scope">{{ scope.row.cbPrice|priceFilter }}</template>
        </el-table-column>
        <el-table-column prop="cbRate" label="毛利率">
          <template slot-scope="scope">{{ scope.row.cbRate|perCentFilter }}</template>
        </el-table-column>
        <el-table-column prop="cbTotal" label="销售总额">
          <template slot-scope="scope">{{ scope.row.cbTotal|priceFilter }}</template>
        </el-table-column>
        <el-table-column prop="taxRate" label="税率">
          <template slot-scope="scope">{{ scope.row.taxRate|perCentFilter }}</template>
        </el-table-column>
        <el-table-column prop="taxAmount" label="税额">
          <template slot-scope="scope">{{ scope.row.taxAmount|priceFilter }}</template>
        </el-table-column>
        <el-table-column prop="cbUnitPrice" label="供货单价" width="120px">
          <template slot-scope="scope">{{ scope.row.cbUnitPrice|priceFilter }}</template>
        </el-table-column>
        <el-table-column prop="cbUnitTotal" label="供货总额" width="120px">
          <template slot-scope="scope">{{ scope.row.cbUnitTotal|priceFilter }}</template>
        </el-table-column>
        <!-- <el-table-column label="备货状态">
          <template slot-scope="scope">{{ scope.row.stockupState|stockupStateFilter}}</template>
        </el-table-column>
        <el-table-column label="发货状态">
          <template slot-scope="scope">{{scope.row.deliverState|deliverStateFilter}}</template>
        </el-table-column>-->
      </el-table>
    </div>
    <!-------------- 工单日志 -------------->
    <operation-log-and-flow :flowLabel="flowLabel" :id="queryParams.id" :typesel="typesel"></operation-log-and-flow>
  </div>
</template>
<script>
import operationLogAndFlow from '@/components/OperationLog/operationLogAndFlow' // 工单日志
import { queryByFinance, queryLogisticsById } from '@/api/sell/sellManage'
export default {
  components: {
    'operation-log-and-flow': operationLogAndFlow
  },
  data () {
    return {
      typesel: 'orderContractInvoice', // 工单日志type值
      flowLabel: '退票流程',
      queryParams: {},
      list: []
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    onContractCode (row) {
      this.$router.push({
        name: 'contractEdit',
        query: { id: row.covenantId, cusId: row.cusId }
      })
    },
    onProductDetail (row) {
      this.$router.push({ name: 'productDetails', query: { id: row.proId } })
    },
    getList () {
      queryByFinance(this.$route.query.oisId)
        .then((res) => {
          if (res.data.code === 200) {
            this.queryParams = res.data.obj
            this.list = res.data.obj.orderContractInvoiceSubContentListVos
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    onStore () {
      // 物流保存
      queryLogisticsById(this.queryParams)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('物流信息修改成功')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
